import { TagSearchIcon } from './TagSearchIcon';

/**
 * author: Michael Irigoyen
 * id 2728D780-6100-4AD5-B5B3-67C64DAF983C
 * name tag-search
 * version: 6.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/tag-search.svg
 * tags
 */
export const TagFindIcon = TagSearchIcon;
export default TagFindIcon